;
document.addEventListener("turbolinks:load", () => {
    if (document.querySelector(".js-one-select-form") !== null) {
        console.log("one select form exists");
        const e = document.querySelector("select")
        e.addEventListener("change", function () {
            document.querySelector("input[type=submit]").disabled = !(e.value.length > 0);
        });
    }
});